<template>
  <div>
    <v-card class="mt-6">
      <v-card-text>
        <v-row>
          <v-col>
            <p class="ma-0 overline primary--text">Lucky Four Winners</p>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="2" class="text-right">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                  class="mr-1"
                  @click="loadGameWinners"
                >
                  <v-icon>mdi-cached</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="winnersFormatted"
          :items-per-page="5"
          :loading="gameWinnersLoading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-row>
              <div v-if="$store.state.accountInfo.access.includes(61)">
                <v-tooltip right v-if="item.bet_status == 'For Verification'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      color="primary"
                      @click="confirmVerify(item)"
                    >
                      <v-icon size="large">
                        mdi-check-underline-circle-outline
                      </v-icon>
                    </v-btn>
                  </template>

                  <span>Verify</span>
                </v-tooltip>

                <v-tooltip right v-if="item.bet_status == 'Verified'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      color="primary"
                      @click="confirmUnverify(item)"
                    >
                      <v-icon size="large"> mdi-arrow-u-left-bottom </v-icon>
                    </v-btn>
                  </template>
                  <span>Unverify</span>
                </v-tooltip>

                <v-btn
                  v-if="item.bet_status == 'Approved'"
                  icon
                  small
                  style="pointer-events: none"
                  class="green--text"
                >
                  <v-icon size="large">
                    mdi-checkbox-marked-circle-outline
                  </v-icon>
                </v-btn>
              </div>

              <div v-if="$store.state.accountInfo.access.includes(62)">
                <v-btn
                  v-if="item.bet_status == 'For Verification'"
                  icon
                  small
                  style="pointer-events: none"
                  class="grey--text"
                >
                  <v-icon size="large">
                    mdi-checkbox-marked-circle-outline
                  </v-icon>
                </v-btn>

                <v-tooltip right v-if="item.bet_status == 'Verified'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      color="primary"
                      @click="confirmApprove(item)"
                    >
                      <v-icon size="large">
                        mdi-checkbox-marked-circle-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Approve</span>
                </v-tooltip>

                <v-btn
                  v-if="item.bet_status == 'Approved'"
                  icon
                  small
                  style="pointer-events: none"
                  class="green--text"
                >
                  <v-icon size="large">
                    mdi-checkbox-marked-circle-outline
                  </v-icon>
                </v-btn>
              </div>
            </v-row>
          </template>

          <template v-slot:[`item.bet_status`]="{ item }">
            <v-chip
              small
              class="font-weight-bold"
              :class="
                item.bet_status == 'Verified'
                  ? 'blue lighten-5 blue--text'
                  : item.bet_status == 'Approved'
                  ? 'green lighten-5 green--text'
                  : 'orange lighten-5 orange--text'
              "
            >
              {{ item.bet_status }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="verifyDialog" max-width="300">
      <v-card class="py-2">
        <v-card-title class="text-h6 d-block text-center">
          Confirm Verify
        </v-card-title>
        <v-card-text class="text-center">
          Do you really want to verify?
        </v-card-text>

        <v-card-actions class="d-block text-center">
          <v-btn
            ref="verifyYes"
            color="primary"
            outlined
            small
            @click="verify"
            :loading="verifyWinnerLoading"
          >
            Yes
          </v-btn>

          <v-btn color="grey" outlined small @click="verifyDialog = false">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unverifyDialog" max-width="300">
      <v-card class="py-2">
        <v-card-title class="text-h6 d-block text-center">
          Confirm Unverify
        </v-card-title>
        <v-card-text class="text-center">
          Do you really want to unverify?
        </v-card-text>

        <v-card-actions class="d-block text-center">
          <v-btn
            ref="unverifyYes"
            color="primary"
            outlined
            small
            @click="unverify"
            :loading="unverifyWinnerLoading"
          >
            Yes
          </v-btn>

          <v-btn color="grey" outlined small @click="unverifyDialog = false">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="approveDialog" max-width="300">
      <v-card class="py-2">
        <v-card-title class="text-h6 d-block text-center">
          Confirm Approve
        </v-card-title>
        <v-card-text class="text-center">
          Do you really want to approve?
        </v-card-text>

        <v-card-actions class="d-block text-center">
          <v-btn
            ref="approveYes"
            color="primary"
            outlined
            small
            @click="approve"
            :loading="approveWinnerLoading"
          >
            Yes
          </v-btn>

          <v-btn color="grey" outlined small @click="approveDialog = false">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="insufficientDialog" max-width="300">
      <v-card class="py-2">
        <v-card-title class="text-h6 d-block text-center">
          Insufficient
        </v-card-title>

        <v-divider />

        <v-card-text class="py-4 text-center red--text">
          Agent points are insufficient.
        </v-card-text>

        <v-card-actions class="d-block text-center">
          <v-btn
            block
            color="primary"
            outlined
            @click="insufficientDialog = false"
          >
            GOT IT!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({
    headers: [
      {
        text: "Action",
        sortable: false,
        value: "action",
        class: "text-uppercase",
        align: "center",
      },
      {
        text: "Player Name",
        sortable: false,
        value: "player_name",
        class: "text-uppercase",
      },
      {
        text: "Combination#",
        sortable: false,
        value: "combination",
        class: "text-uppercase",
      },
      {
        text: "Bet Amount",
        sortable: false,
        value: "formattedBetAmount",
        class: "text-uppercase",
      },
      {
        text: "Prize",
        sortable: false,
        value: "formattedPrize",
        class: "text-uppercase",
      },
      { text: "Status", value: "bet_status", class: "text-uppercase" },
    ],
    verifyDialog: false,
    verifyBetId: "",
    unverifyDialog: false,
    unverifyBetId: "",
    approveDialog: false,
    approveBetId: "",
    insufficientDialog: false,
  }),

  computed: {
    ...mapState("lucky_four_game_details", [
      "gameWinners",
      "gameWinnersLoading",
      "verifyWinnerError",
      "verifyWinnerLoading",
      "unverifyWinnerError",
      "unverifyWinnerLoading",
      "approveWinnerError",
      "approveWinnerLoading",
    ]),

    winnersFormatted() {
      if (this.gameWinners) {
        return this.gameWinners.map((winner) => {
          return {
            ...winner,
            formattedBetAmount:
              "PHP " + this.moneyFormat(parseFloat(winner.bet_amount)),
            formattedPrize: "PHP " + this.moneyFormat(parseFloat(winner.prize)),
          };
        });
      } else {
        return [];
      }
    },
  },

  methods: {
    ...mapActions("lucky_four_game_details", [
      "getGameWinners",
      "verifyWinner",
      "unverifyWinner",
      "approveWinner",
    ]),

    moneyFormat(val) {
      return val.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    loadGameWinners() {
      if (!this.gameWinnersLoading) {
        this.$store.commit("lucky_four_game_details/setGameWinners", []);
        this.getGameWinners(this.$route.params.id);
      }
    },

    confirmVerify(item) {
      this.verifyDialog = true;
      this.verifyBetId = item.ending_bet_id;
    },

    async verify() {
      const formData = new FormData();
      formData.append("game_id", this.$route.params.id);
      formData.append("ending_bet_id", this.verifyBetId);

      if (!this.verifyWinnerLoading) {
        await this.verifyWinner(formData);

        if (!this.verifyWinnerError) {
          this.verifyDialog = false;

          this.gameWinners.find(
            (winner) => winner.ending_bet_id == this.verifyBetId
          ).bet_status = "Verified";
        }
      }
    },

    confirmUnverify(item) {
      this.unverifyDialog = true;
      this.unverifyBetId = item.ending_bet_id;
    },

    async unverify() {
      const formData = new FormData();
      formData.append("game_id", this.$route.params.id);
      formData.append("ending_bet_id", this.unverifyBetId);

      if (!this.unverifyWinnerLoading) {
        await this.unverifyWinner(formData);

        if (!this.unverifyWinnerError) {
          this.unverifyDialog = false;

          this.gameWinners.find(
            (winner) => winner.ending_bet_id == this.unverifyBetId
          ).bet_status = "For Verification";
        }
      }
    },

    confirmApprove(item) {
      this.approveDialog = true;
      this.approveBetId = item.ending_bet_id;
    },

    async approve() {
      const formData = new FormData();
      formData.append("game_id", this.$route.params.id);
      formData.append("ending_bet_id", this.approveBetId);

      if (!this.approveWinnerLoading) {
        await this.approveWinner(formData);

        if (!this.approveWinnerError) {
          this.approveDialog = false;

          this.gameWinners.find(
            (winner) => winner.ending_bet_id == this.approveBetId
          ).bet_status = "Approved";
        } else {
          this.approveDialog = false;
          this.insufficientDialog = true;
        }
      }
    },
  },
};
</script>